module.exports = __webpack_public_path__ + "img/802.08428175.png";